import React from 'react';
import './App.css';
import EACBillCalculator from './components/EACBillCalculator';

function App() {
  return (
    <div className="App">
      <EACBillCalculator />
    </div>
  );
}

export default App; 
